<template>
    <div class="validCalculator">
        ====================》这是validCalculator页
    </div>
</template>
<script>
export default {
    name:'validCalculator',
      data() {
        return {
        
        }
    },
    mounted(){
        
    },
    methods: {
        
    }
}
</script>

<style>

</style>




// WEBPACK FOOTER //
// validCalculator.vue?3b1f14cd